// Port de app/(tabs)/ordemServico.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const OrdemServicoScreen = lazy(() => import("@/screens/OrdemServico"));

export default function OrdemServicoRoute() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <OrdemServicoScreen />
    </Carregando>
  ) : null;
}
